import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getStandEvents } from "../../../../context/events/action";
import EventBox from "../../../../components/events/box";
import { IToastContext, ToastContext } from "../../../../providers/Toast";
import { DB_DEFAULTS } from "../../../../firebase/collections";
import Button from "../../../../components/shared/button/Button";
import { Event, Stand } from "../../../../data/interfaces";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
}

const StandDetailEventsTabView = ({ stand, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Loading list
  const [loading, setLoading] = useState<boolean>(false);

  // Eventual error
  const [errors, setErrors] = useState<any>(false);

  // Local array of data
  const [events, setEvents] = useState<Event[]>([]);

  // Pagination
  const [lastItem, setLastItem] = useState<any>(null);
  const [limit, setLimit] = useState<number>(DB_DEFAULTS.LIMIT);
  const [canLoadMore, setCanLoadMore] = useState<boolean>(true);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Load events from database
   * @function
   * @async
   */
  const loadEvents = async () => {
    setLoading(true);

    try {
      const data = await getStandEvents(stand.id, limit, lastItem);

      if (!data || data.length < limit) {
        setCanLoadMore(false);
      }

      // Track last element value for pagination
      setLastItem(data[data.length - 1]);

      setEvents([...events, ...data]);
    } catch (err) {
      setErrors(err);
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {
        },
      });
    } finally {
      setLoading(false);
    }
  };

  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandDetailEventsTabView] init");
    loadEvents();
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandDetailEventsTabView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------

  return (
    <div className={`panel-content events-list lite ${events.length === 0 ? "no-data" : ""}`}>
      {events && events.length > 0 ? (
        <div className={"row"}>
          {events.map((event: Event) => (
            <div className={"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xlg-4"} key={event.id}>
              <EventBox event={event}/>
            </div>
          ))}
        </div>
      ) : (
        <span>{t("pages.standDetail.tabs.noData")}</span>
      )}

      {!!loading && (
        <div className="list-loading">
          <i className="fas fa-spin fa-spinner"></i>
        </div>
      )}

      {/* Load more button */}
      {!loading && !!canLoadMore && (
        <div className="load-more">
          <Button className="btn btn-primary" onClick={loadEvents}>
            Load more
          </Button>
        </div>
      )}
    </div>
  );
};
export default StandDetailEventsTabView;
